import { c as _c } from "react/compiler-runtime";
import { Toggle as TogglePrimitive } from "@base-ui/react/toggle";
import { cn, cva, type VariantProps } from "../utils";
const toggleVariants = cva({
  base: "group/toggle inline-flex cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:cursor-default aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  variants: {
    variant: {
      default: "bg-transparent",
      secondary: "bg-background hover:bg-muted aria-pressed:bg-primary aria-pressed:text-primary-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50 dark:aria-pressed:bg-primary dark:aria-pressed:text-primary-foreground",
      outline: "border border-input bg-transparent hover:bg-muted"
    },
    size: {
      default: "h-9 min-w-9 px-2",
      sm: "h-8 min-w-8 px-1.5",
      lg: "h-10 min-w-10 px-2.5"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function Toggle(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = cn(toggleVariants({
      variant,
      size,
      className
    }));
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <TogglePrimitive data-slot="toggle" className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export { Toggle, toggleVariants };